module.exports = __webpack_public_path__ + "static/media/logo192.11c543ab.png";